/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Pizza Checker API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { PutUpdateBranchFlagsBody } from ".././schemas";

import { customInstance } from "../../axios-instance";
import type { ErrorType, BodyType } from "../../axios-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get branches from database with flags
 */
export const getBranchesFromDb = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    { url: `/api/integration/biteberry/branches`, method: "GET", signal },
    options,
  );
};

export const getGetBranchesFromDbQueryKey = () => {
  return [`/api/integration/biteberry/branches`] as const;
};

export const getGetBranchesFromDbQueryOptions = <
  TData = Awaited<ReturnType<typeof getBranchesFromDb>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getBranchesFromDb>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBranchesFromDbQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBranchesFromDb>>
  > = ({ signal }) => getBranchesFromDb(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBranchesFromDb>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBranchesFromDbQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBranchesFromDb>>
>;
export type GetBranchesFromDbQueryError = ErrorType<unknown>;

export function useGetBranchesFromDb<
  TData = Awaited<ReturnType<typeof getBranchesFromDb>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBranchesFromDb>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBranchesFromDb>>,
          TError,
          Awaited<ReturnType<typeof getBranchesFromDb>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBranchesFromDb<
  TData = Awaited<ReturnType<typeof getBranchesFromDb>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBranchesFromDb>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBranchesFromDb>>,
          TError,
          Awaited<ReturnType<typeof getBranchesFromDb>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBranchesFromDb<
  TData = Awaited<ReturnType<typeof getBranchesFromDb>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBranchesFromDb>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get branches from database with flags
 */

export function useGetBranchesFromDb<
  TData = Awaited<ReturnType<typeof getBranchesFromDb>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBranchesFromDb>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBranchesFromDbQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update branch evaluation and acquisition flags
 */
export const putUpdateBranchFlags = (
  bbBranchId: string,
  putUpdateBranchFlagsBody: BodyType<PutUpdateBranchFlagsBody>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<unknown>(
    {
      url: `/api/integration/biteberry/branches/${bbBranchId}/flags`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: putUpdateBranchFlagsBody,
    },
    options,
  );
};

export const getPutUpdateBranchFlagsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putUpdateBranchFlags>>,
    TError,
    { bbBranchId: string; data: BodyType<PutUpdateBranchFlagsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putUpdateBranchFlags>>,
  TError,
  { bbBranchId: string; data: BodyType<PutUpdateBranchFlagsBody> },
  TContext
> => {
  const mutationKey = ["putUpdateBranchFlags"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putUpdateBranchFlags>>,
    { bbBranchId: string; data: BodyType<PutUpdateBranchFlagsBody> }
  > = (props) => {
    const { bbBranchId, data } = props ?? {};

    return putUpdateBranchFlags(bbBranchId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutUpdateBranchFlagsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putUpdateBranchFlags>>
>;
export type PutUpdateBranchFlagsMutationBody =
  BodyType<PutUpdateBranchFlagsBody>;
export type PutUpdateBranchFlagsMutationError = ErrorType<unknown>;

/**
 * @summary Update branch evaluation and acquisition flags
 */
export const usePutUpdateBranchFlags = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putUpdateBranchFlags>>,
      TError,
      { bbBranchId: string; data: BodyType<PutUpdateBranchFlagsBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putUpdateBranchFlags>>,
  TError,
  { bbBranchId: string; data: BodyType<PutUpdateBranchFlagsBody> },
  TContext
> => {
  const mutationOptions = getPutUpdateBranchFlagsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postUpdateMenu = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    { url: `/api/integration/biteberry/update_menu`, method: "POST", signal },
    options,
  );
};

export const getPostUpdateMenuMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUpdateMenu>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUpdateMenu>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postUpdateMenu"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUpdateMenu>>,
    void
  > = () => {
    return postUpdateMenu(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostUpdateMenuMutationResult = NonNullable<
  Awaited<ReturnType<typeof postUpdateMenu>>
>;

export type PostUpdateMenuMutationError = ErrorType<unknown>;

export const usePostUpdateMenu = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postUpdateMenu>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postUpdateMenu>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostUpdateMenuMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postUpdateOrderV2 = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    { url: `/api/integration/biteberry/v2/update`, method: "POST", signal },
    options,
  );
};

export const getPostUpdateOrderV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUpdateOrderV2>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUpdateOrderV2>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postUpdateOrderV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUpdateOrderV2>>,
    void
  > = () => {
    return postUpdateOrderV2(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostUpdateOrderV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof postUpdateOrderV2>>
>;

export type PostUpdateOrderV2MutationError = ErrorType<unknown>;

export const usePostUpdateOrderV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postUpdateOrderV2>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postUpdateOrderV2>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostUpdateOrderV2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postUpdateOrderItemV2 = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/integration/biteberry/v2/update_item`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getPostUpdateOrderItemV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUpdateOrderItemV2>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUpdateOrderItemV2>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postUpdateOrderItemV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUpdateOrderItemV2>>,
    void
  > = () => {
    return postUpdateOrderItemV2(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostUpdateOrderItemV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof postUpdateOrderItemV2>>
>;

export type PostUpdateOrderItemV2MutationError = ErrorType<unknown>;

export const usePostUpdateOrderItemV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postUpdateOrderItemV2>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postUpdateOrderItemV2>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostUpdateOrderItemV2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
